import { TimelineItem } from 'element-ui'

const YTimelineItem = TimelineItem
YTimelineItem.$depends = [TimelineItem]
YTimelineItem.$name = 'y-timeline-item'
YTimelineItem._name = 'TimelineItem 时间线选项'

export default YTimelineItem
